import React from "react";
import { TextField } from "@mui/material";
import { Field } from "react-final-form";
import { FormFieldWrapper } from "../common/components/FormFields/FormFieldWrapper";
import { normalizePostalCode, validatePostalCode } from "./postalCode";

export function OtlPostalCodeField({
  name,
  required,
}: {
  name: string;
  required?: boolean;
}) {
  return (
    <FormFieldWrapper noIcon>
      <Field
        name={name}
        validate={(value) => validatePostalCode(value, required)}
      >
        {({ input, meta }) => (
          <TextField
            {...input}
            fullWidth
            size="small"
            label="Postal Code"
            required={required}
            onBlur={(event) => {
              input.onChange(normalizePostalCode(input.value || ""));
              input.onBlur(event);
            }}
            error={Boolean(
              (meta.touched || meta.submitFailed) &&
                (meta.error ||
                  (!meta.dirtySinceLastSubmit && meta.submitError)),
            )}
            helperText={
              (meta.touched || meta.submitFailed) &&
              (meta.error || (!meta.dirtySinceLastSubmit && meta.submitError))
            }
          />
        )}
      </Field>
    </FormFieldWrapper>
  );
}
